export default class MaskList {

	static phoneWithPrefix: string = '+998 ## ###-##-##'

	static phone: string = '+### ## ###-##-##'

	static date: string = '##.##.####'

	static inn: string = MaskList.generateLattice(9)

	static pinfl: string = MaskList.generateLattice(14)

	static cardNumber: string = '#### #### #### ####'

	static mfo: string = MaskList.generateLattice(5)

	static idn: string = MaskList.generateLattice(27)

	static treasureAccount: string = MaskList.generateLattice(25)

	static account: string = MaskList.generateLattice(20)

	static formattedAccount: string = '##### ### # ######## ###'

	static formattedCardNumber: string = '#### ##** **** ####'

	static smsCode: string = MaskList.generateLattice(4)

	static unpaidCode: string = MaskList.generateLattice(4)

	static debtCode: string = MaskList.generateLattice(3)

	static purposeCode: string = MaskList.generateLattice(5)

	static generateLattice(count: number): string {
		return '#'.repeat(count);
	}

}